module.exports = __webpack_public_path__ + "img/246.d4f656ce.jpg";